export default __webpack_public_path__ + "assets/webgl/picking-21.a8fea970.glb";